
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/deepresearch/methodology",
      function () {
        return require("private-next-pages/deepresearch/methodology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/deepresearch/methodology"])
      });
    }
  